import { SportType } from '@/interface/enum';
import { invertCapitalize } from '@/libraries/string';

export function getSportIconName(sportType: SportType) {
    return `sportIcon_color_${invertCapitalize(SportType[sportType])}`;
}
